export interface NestedProgressParams {
  currentPage: string;
  currentSection: number;
  totalSections: number;
  stepGroups: string[][];
  currentDriver?: number;
}

export const calculateNestedProgress = (
  params: NestedProgressParams
): number => {
  const {
    currentPage,
    currentSection,
    totalSections,
    stepGroups,
    currentDriver = 0,
  } = params;

  if (currentSection < 1 || currentSection > totalSections) {
    console.warn(
      `Invalid section: ${currentSection}. Must be between 1 and ${totalSections}`
    );
    return 0;
  }

  if (totalSections <= 0) {
    console.warn("totalSections must be greater than 0");
    return 0;
  }

  // Count occurrences of currentPage to find the correct instance (for multi-driver)
  let pageIndex = -1;
  let occurrenceCount = 0;
  for (let i = 0; i < stepGroups.length; i++) {
    if (stepGroups[i][0] === currentPage) {
      if (occurrenceCount === currentDriver) {
        pageIndex = i;
        break;
      }
      occurrenceCount++;
    }
  }

  if (pageIndex === -1) {
    console.warn(
      `Page "${currentPage}" occurrence #${currentDriver + 1} not found`
    );
    return 0;
  }

  const totalPages = stepGroups.length;
  const pageWeight = 100 / totalPages;

  const completedPagesProgress = pageIndex * pageWeight;

  const sectionProgress = Math.min(currentSection / totalSections, 1);
  const currentPageProgress = sectionProgress * pageWeight;

  return Math.min(completedPagesProgress + currentPageProgress, 100);
};
